import { useElementSize } from './use-element-size'

/**
 * Hook that uses a resize observer to measure the size of an element
 *
 * @param {Object} elementRef - element for which the size should be monitored
 * @returns {Number} - size of the element in px
 */
export function useElementWidth(elementRef) {
    const size = useElementSize(elementRef)

    return size?.width ?? 0
}
